/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../utils/Functions';
import { params } from '../../../../../redux/reducers/reducer';
import { Instance, Instances } from '@react-three/drei';

const SingleVent = ({width, height, trimWidth}) => {
  
    const trimColor = useMemo(() => {
        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    const ventRailCount = Math.floor(((height - trimWidth)) / 0.1);

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2), (height / 2));
        model.lineTo((width / 2), (height / 2));
        model.lineTo((width / 2), -(height / 2));
        model.lineTo(-(width / 2), -(height / 2));
        model.closePath();

        const holeModel = new THREE.Shape();
        holeModel.moveTo(-(width / 2 - trimWidth), (height / 2 - trimWidth));
        holeModel.lineTo((width / 2 - trimWidth), (height / 2 - trimWidth));
        holeModel.lineTo((width / 2 - trimWidth), -(height / 2 - trimWidth));
        holeModel.lineTo(-(width / 2 - trimWidth), -(height / 2 - trimWidth));
        holeModel.closePath();

        model.holes.push(holeModel);

        return model;
    }, [width, height]);


    const railModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - trimWidth), 0);
        model.lineTo((width / 2 - trimWidth), 0);
        model.lineTo((width / 2 - trimWidth), -0.03);
        model.lineTo(-(width / 2 - trimWidth), -0.03);
        model.closePath();

        return model;
    }, [width]);
        
    return (
        <group castShadow receiveShadow>
        <mesh castShadow receiveShadow name="trim">
            <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
            <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
        </mesh>
        <Instances castShadow receiveShadow>
            <extrudeGeometry args={[railModel, extrudeSettings(0.1)]} />
            <meshStandardMaterial  color={'#ffffff'} side={THREE.DoubleSide} roughness={0.3} metalness={0.2} />

            {new Array(ventRailCount).fill("").map((_, index) => (
                <group castShadow receiveShadow key={`vent-rail-${index}`} position={[0, (height / 2 - trimWidth) - 0.1 * index, 0.2]} rotation={[Math.PI / 4, 0, 0]}>
                    <Instance castShadow receiveShadow />
                </group>
            ))}
        </Instances>
        </group>
    )
}

export default SingleVent;